import { Flex } from "@chakra-ui/react";
import TagByResourceType from "components/Tag/TagByResourceType";
import NameField from "features/Resources/Shared/Components/Fields/NameField";
import { fromActionPrefixId } from "features/Resources/Shared/helpers";
import { ActionType, ActionV2 } from "features/Resources/Shared/models";
import { UseFormReturn } from "react-hook-form";

interface ActionHeaderProps {
  form: UseFormReturn<any>;
  action: ActionV2 | undefined;
  isDisabled: boolean | undefined;
}

export default function ActionHeader({ form, action, isDisabled = false }: ActionHeaderProps) {
  if (!action) {
    return null;
  }
  const { resourceType } = fromActionPrefixId(action.prefixId);
  return (
    <Flex w="100%" justify="space-between" align="center">
      <NameField sx={{ w: "50%" }} form={form} disabled={isDisabled} />
      <TagByResourceType type={resourceType as ActionType} />
    </Flex>
  );
}
